var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.854,
    height: 25.855,
    viewBox: "0 0 25.854 25.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "complete",
    transform: "translate(-561.917 -1099.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-out-icon-green",
    transform: "translate(561.917 1099.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checked-out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M574.844,1125.11a12.928,12.928,0,1,1,12.927-12.928,12.942,12.942,0,0,1-12.927,12.928",
    transform: "translate(-561.917 -1099.255)",
    fill: "#23bb79",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M579.036,1105.5a1.728,1.728,0,0,0-2.348,0l-5.536,5.536-1.68-1.68a1.661,1.661,0,0,0-2.352,2.345l1.462,1.384,1.473,1.474a1.629,1.629,0,0,0,2.271,0l6.71-6.709a1.73,1.73,0,0,0,0-2.349",
    transform: "translate(1.763 2.149)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.2b90140724d346bce8af421c1074db9f.svg";
export { ForwardRef as ReactComponent };